import {GET_ALL_BANNER_START} from "../../types";

export const banners = (payload) => ({
  type: GET_ALL_BANNER_START,
  payload,
});
